import type { GenerationTool } from 'src/data/generationTool';
// @ts-expect-error - useAnalyzerTonesOfVoice has no TypeScript declarations
import { useAnalyzerTonesOfVoice } from 'src/services/useAnalyzerTonesOfVoice';
// @ts-expect-error - useTextExtractToneOfVoiceDebounced has no TypeScript declarations
import { useTextExtractToneOfVoiceDebounced } from 'src/services/useTextExtractToneOfVoiceDebounced';
// @ts-expect-error - project store has no TypeScript declarations
import { useCurrentProjectId } from 'src/store/project/useCurrentProjectId';

import { LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT } from './longFormConst';

interface Params {
  text: string;
  generationTool?: GenerationTool | null;
  language?: string | null;
}

export const useLongFormToneOfVoiceInsightsData = ({ text, generationTool, language }: Params) => {
  const projectId = useCurrentProjectId();
  const { analyzerToneOfVoice } = useAnalyzerTonesOfVoice({ generationTool, language });

  return useTextExtractToneOfVoiceDebounced(
    { projectId, text, customTovId: analyzerToneOfVoice?.id },
    { debounceTimeout: LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT }
  );
};
